import {
  countTotalProductsPerAvailability,
  IProductListPatchModelItem,
} from '@epicuro-next/data/lists';
import { List } from '@epicuro-next/models/engagement';

interface OpenedListProductsTotalPerAvailability {
  list: List | null;
  total: number | null;
  totalAvailable?: number;
}

interface CalculatedTotals {
  totalAvailable: number;
  total: number;
  amount: number;
  currentPage: number;
}

export function mapAvailableUnavailableTotalProducts(
  products: IProductListPatchModelItem[],
  { totalAvailable = 0, total, list }: OpenedListProductsTotalPerAvailability,
) {
  const totalProducts = total ?? 0;
  const totalAmount = list?.amount ?? 0;

  const totalProductsCount = products.length;

  const totalProductsPerAvailability =
    countTotalProductsPerAvailability(products);

  const [{ isSourceFromOpenedList = true }] = products;

  if (isSourceFromOpenedList) {
    const newTotalAvailable =
      totalAvailable + totalProductsPerAvailability.available;

    const newTotal = totalProducts + totalProductsCount;
    const newAmount = totalAmount + totalProductsCount;

    return {
      totalProductsPerAvailability,
      totalAvailable: newTotalAvailable,
      total: newTotal,
      amount: newAmount,
    };
  } else {
    return {
      totalProductsPerAvailability,
      totalAvailable,
      total: totalProducts,
      amount: totalAmount,
    };
  }
}

export function calculateTotalProductsOnDelete(
  amountDeleted: number,
  pageSize: number,
  currentTotal: number | null,
  currentTotalAvailable: number | undefined,
  list: List | null,
): CalculatedTotals {
  const newPage = Math.floor(list?.productsReference?.length ?? 0 / pageSize);
  const page = newPage > 0 ? newPage : 1;

  const total = currentTotal ? currentTotal - amountDeleted : 0;
  const amount = list?.amount ? list?.amount - amountDeleted : 0;

  let newTotalAvailable = 0;

  if (currentTotalAvailable) {
    newTotalAvailable = currentTotalAvailable - amountDeleted;
  }

  return {
    amount,
    currentPage: page,
    total,
    totalAvailable: newTotalAvailable,
  };
}
